export default "__VITE_ASSET__51dafc08__"